module.exports = __webpack_public_path__ + "img/female.048ec8e9.svg";